<app-marine-insurance-card cardTitle="PAYMENT_DETAILS">
  <ng-container header-actions-button>
    <div class="marine-insurance-payments-management-bill-link" *ngIf="isRefundNonPendingOrCompleted" (click)="goToBill()">
      <span>{{ "GO_TO_BILL" | translate }}</span>
      <img src="assets/icons/icon_chevron_up.svg" />
    </div>
  </ng-container>

  <ng-container body>
    <div class="marine-insurance-payments-management">
      <div
        class="marine-insurance-payments-management-row"
        [ngClass]="{ 'marine-insurance-payments-management-row-first': isShowSecondLine }"
      >
        <div class="marine-insurance-payments-management-col">
          <div class="marine-insurance-payments-management-col-label">{{ "INSURED_VALUE" | translate }}</div>
          <div class="marine-insurance-payments-management-col-value">
            {{
              (isShowInitialValue ? marineInsurance?.insuredValue?.insuredAmount : marineInsurance?.updatedInsuredValue?.insuredAmount)
                | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2"
            }}
          </div>
        </div>

        <div class="marine-insurance-payments-management-col">
          <div class="marine-insurance-payments-management-col-label">{{ "PREMIUM" | translate }}</div>
          <div class="marine-insurance-payments-management-col-value">
            {{
              (isShowInitialValue ? marineInsurance?.certificate?.providerCost : marineInsurance?.certificate?.updatedProviderCost)
                | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2"
            }}
          </div>
        </div>

        <div class="marine-insurance-payments-management-col">
          <div class="marine-insurance-payments-management-col-label">
            {{ "EEZY_PROCESSING_FEE" | translate }}
          </div>
          <div class="marine-insurance-payments-management-col-value">
            {{
              (isShowInitialValue ? marineInsurance?.certificate?.handlingFee : marineInsurance?.certificate?.updatedHandlingFee)
                | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2"
            }}
          </div>
        </div>

        <div class="marine-insurance-payments-management-col marine-insurance-payments-management-col-no-border">
          <div class="marine-insurance-payments-management-col-label">
            {{ "LABELS.AMOUNT" | translate }}
          </div>
          <div class="marine-insurance-payments-management-col-value">
            {{
              (isShowInitialValue
                ? marineInsurance?.certificate?.handlingFee + marineInsurance?.certificate?.providerCost
                : marineInsurance?.certificate?.updatedHandlingFee + marineInsurance?.certificate?.updatedProviderCost
              ) | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2"
            }}
          </div>
        </div>

        <div class="marine-insurance-payments-management-col marine-insurance-payments-management-col-payment-status">
          <div
            class="marine-insurance-payments-management-col-payment"
            [style.background-color]="isRefundCompleted ? paymentStatusColorRefunded : paymentStatusColorSuccess"
          >
            {{ (isRefundCompleted ? "PAYMENT_STATE.REFUNDED" : currentPaymentStatusText) | translate }}
          </div>
        </div>
      </div>

      <div class="marine-insurance-payments-management-row" *ngIf="isShowSecondLine">
        <div class="marine-insurance-payments-management-col">
          <div class="marine-insurance-payments-management-col-label">{{ "INSURED_VALUE" | translate }}</div>
          <div class="marine-insurance-payments-management-col-value">
            {{ marineInsurance?.updatedInsuredValue?.insuredAmount | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
          </div>
        </div>

        <div class="marine-insurance-payments-management-col">
          <div class="marine-insurance-payments-management-col-label">{{ "PREMIUM" | translate }}</div>
          <div class="marine-insurance-payments-management-col-value marine-insurance-payments-management-col-value-highlighted">
            {{ marineInsurance?.certificate?.updatedProviderCost | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
          </div>
        </div>

        <div class="marine-insurance-payments-management-col">
          <div class="marine-insurance-payments-management-col-label">
            {{ "EEZY_PROCESSING_FEE" | translate }}
          </div>
          <div class="marine-insurance-payments-management-col-value marine-insurance-payments-management-col-value-highlighted">
            {{ marineInsurance?.certificate?.updatedHandlingFee | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
          </div>
        </div>

        <div class="marine-insurance-payments-management-col marine-insurance-payments-management-col-no-border">
          <div class="marine-insurance-payments-management-col-label">
            {{ "NEW_PRICE" | translate }}
          </div>
          <div class="marine-insurance-payments-management-col-value marine-insurance-payments-management-col-value-highlighted">
            {{
              marineInsurance?.certificate?.updatedHandlingFee + marineInsurance?.certificate?.updatedProviderCost
                | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2"
            }}
          </div>
        </div>

        <div class="marine-insurance-payments-management-col marine-insurance-payments-management-col-payment-status">
          <div class="marine-insurance-payments-management-col-payment" [style.background-color]="paymentStatusColor">
            {{ paymentStatusText | translate }}
          </div>
        </div>
      </div>

      <div class="marine-insurance-payments-management-row marine-insurance-payments-management-row-btn" *ngIf="isRefundPending">
        <button type="button" class="marine-insurance-payments-management-btn-confirm" (click)="confirmRefund.emit()">
          {{ "CONFIRM_PARTIAL_REFUND_AND_APPLY_UPDATED_DETAILS" | translate }}
        </button>
      </div>
    </div>
  </ng-container>
</app-marine-insurance-card>
